module.exports = __webpack_public_path__ + "img/female_S_01.b58d43a1.png";